import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import {LatLong} from 'src/pages/camera-config/components/camera-general-data/CameraGeneralDataProps'
import api, {CameraConfiguration, EditAddressInfo} from 'src/services/api'
import {CameraConfigurationValidator} from 'src/types'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

type UpdateCameraData = {
  cameraConfig: Partial<CameraConfiguration>
  cameraId: number
  latLong?: LatLong
  cameraName?: string
  addressInfo?: EditAddressInfo
  serverId?: number
}

export default function useUpdateCamera() {
  const {enqueueSnackbar} = useSnackbar()
  const client = useQueryClient()

  const mutation = useMutation({
    mutationFn: async ({cameraConfig, latLong, cameraName, addressInfo, cameraId, serverId}: UpdateCameraData) => {
      if (cameraConfig.receiveMode) cameraConfig.receiveModeId = cameraConfig.receiveMode.id
      delete cameraConfig.sensitivity
      const configuration = new CameraConfigurationValidator(cameraConfig)
      return await api.camera.updateCamera(cameraId, {
        longitude: !latLong?.longitude || latLong?.longitude === '-' ? undefined : Number(latLong?.longitude),
        latitude: !latLong?.latitude || latLong?.latitude === '-' ? undefined : Number(latLong?.latitude),
        configuration,
        addressInfo: addressInfo,
        name: cameraName,
        serverId,
      })
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Erro ao atualizar a configuração')
    },
    onSuccess: () => {
      enqueueSnackbar('Alterações salvas com sucesso', {
        variant: 'success',
      })
    },
    onSettled: async () => {
      await client.invalidateQueries({queryKey: [QueryKeyEnum.CAMERA]})
      await client.invalidateQueries({queryKey: [QueryKeyEnum.CAMERAS]})
    },
  })

  return mutation
}
